import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp';
import getCountryISO2 from 'country-iso-3-to-2';
import styled from '@emotion/styled';
import withTranslation from '../../hoc/withTranslation';
import '@here/maps-api-for-javascript/bin/mapsjs-ui.css';
import {
  createBaseLayers,
  createMap,
  createSettingsControl,
  createUI,
  setUnitSystem,
} from '../../utils/map/MapUtils';
import NewMapMarker from './MapMarkers/NewMapMarker';
import HereLocationSelector from './HereLocationSelector';

const StyledMap = styled.div({
  width: '100%',
  overflow: 'hidden',
  position: 'fixed',
  height: 'calc(100vh - 3rem)',
});

const NewMap = ({ user, oAuth, display, mapData }) => {
  const mapRef = useRef(null);
  const mapUIRef = useRef(null);
  const settingsControlRef = useRef(null);
  const map = useRef(null);
  const currentStep = useSelector((state) => state.usageContext.currentStep);

  const ISO2Code = getCountryISO2(user.politicalView);
  const engineType = H.Map.EngineType.HARP;
  const mapLayers = createBaseLayers(engineType, user.language, ISO2Code);

  useEffect(() => {
    if (!map.current) {
      map.current = createMap(mapLayers, mapRef, engineType);
      const settingsControl = createSettingsControl(mapLayers);
      mapUIRef.current = createUI(mapLayers, map.current, settingsControl);
      settingsControlRef.current = settingsControl;
      setUnitSystem(mapUIRef.current, user.distance);
    }
  }, [mapLayers, user.distance]);

  useEffect(() => {
    if (mapUIRef.current) setUnitSystem(mapUIRef.current, user.distance);
  }, [user.distance]);

  return (
    <StyledMap ref={mapRef}>
      {map.current && (
        <>
          <NewMapMarker
            display={display}
            map={map.current}
            mapData={mapData}
            ui={mapUIRef}
            user={user}
            oAuth={oAuth}
          />
          <HereLocationSelector
            map={map.current}
            oAuth={oAuth}
            display={display}
            allowRightClick={currentStep === 2}
          />
        </>
      )}
    </StyledMap>
  );
};

export default withTranslation(NewMap);
